// SELECT SIZE TXT & DISABLE ADD TO CART ON PAGE LOAD

$(document).ready(function() {
    function checkSizeVariant() {
      if ($('.product-info__block-item .option_downcase-size').length > 0) {
        $('form[action="/cart/add"] button.button').addClass('select_size_btn');
        $('form[action="/cart/add"] button.button').html('Select size');      
        $('.option_downcase-size').addClass('disabled_selected_block');
  
      }
    }
    checkSizeVariant();

  $('.product-card__quick-add-button').click(function() {
    setTimeout(() => {
      checkSizeVariant();      
    }, 1050)
  });
});

$(document).on('click', '.option_downcase-size label', function(e){
  $(this).parents('.product-info__block-list').find('form[action="/cart/add"] button.button').removeClass('select_size_btn');
  $(this).parents('.product-info__block-list').find('form[action="/cart/add"] button.button').html('Add to cart');   
  $(this).parents('.product-info__block-list').find('.option_downcase-size').removeClass('disabled_selected_block');
});

$(document).on('click', '.select_size_btn', function(e){
  e.preventDefault();
  e.stopPropagation();
});


// Expand Cart Note

$("#gift-checkbox").click(function(){
$("textarea#cartSpecialInstructions").toggle();
});

// Footer Accordion Mobile
$('.accordionnn').click(function(){
    if ($(window).width() <= 767) {
        $(this).toggleClass('up');
        $(this).siblings('.panell').slideToggle('fast');
    }
});
// Main Categories Menu Above the Logo (mobile/tablet)
if (window.location.href.indexOf("kids") > -1 || window.location.href.indexOf("boys") > -1 || window.location.href.indexOf("mini-me-collection")  > -1) {
    jQuery('body').addClass('kids-section');
    jQuery(".nav-main-mobile #men-section").removeClass("active");
    jQuery(".nav-main-mobile #kids-section").addClass("active");
    $('#main-header-logo').attr('href', '/pages/kids');
    $('.header__logo-image').attr('src', 'https://cdn.shopify.com/s/files/1/1150/4428/files/JCKidsLogo.png');
    $('.header__logo-image').attr('srcset', 'https://cdn.shopify.com/s/files/1/1150/4428/files/JCKidsLogo.png');
  
}  else if (window.location.href.indexOf("women") > -1){
    jQuery('body').addClass('women-section');
    jQuery(".nav-main-mobile #men-section").removeClass("active");
    jQuery(".nav-main-mobile #women-section").addClass("active");
    $('#main-header-logo').attr('href', '/collections/womens-outerwear');
    $('.header__logo-image').attr('src', 'https://cdn.shopify.com/s/files/1/1150/4428/files/JCWomenLogo.png');
    $('.header__logo-image').attr('srcset', 'https://cdn.shopify.com/s/files/1/1150/4428/files/JCWomenLogo.png');
    
}  else if (window.location.href.indexOf("big-men") > -1){
   jQuery('body').addClass('big-mens-section');
   jQuery(".nav-main-mobile #men-section").removeClass("active");
   jQuery(".nav-main-mobile #bigmens-section").addClass("active");
   $('#main-header-logo').attr('href', '/pages/big-men-home-page');
   $('.header__logo-image').attr('src', 'https://cdn.shopify.com/s/files/1/1150/4428/files/JCBigMenLogo.png');
   $('.header__logo-image').attr('srcset', 'https://cdn.shopify.com/s/files/1/1150/4428/files/JCBigMenLogo.png');


} else {
    jQuery('body').addClass('mens-section');
    jQuery('.header-logo-fix > a').attr("data-site", "mens").attr("href", "/");
    jQuery('.header-logo-fix img').attr("src", "//cdn.shopify.com/s/files/1/1150/4428/files/logo-jcmen.png");
} 

